import { listAllPapeisObra } from "@/modules/recursos";

/** Nome do papel da alocação (`papelObraId` na lista de papéis do bff); `undefined` sem id ou id desconhecido. */
export async function nomeDoPapel(papelObraId: string | null): Promise<string | undefined> {
  if (!papelObraId) return undefined;
  const papeis = await listAllPapeisObra();
  return papeis.find((papel) => papel.id === papelObraId)?.nome;
}
